import styles from './Home.module.css';

import Background from "@/commons/pages/borders/background/Background";
import Header from "@/commons/pages/borders/header/Header";
import Footer from "@/commons/pages/borders/footer/Footer";
import React, {useEffect, useRef, useState} from 'react';
import {environment} from "@/commons/configs/Config";
import flame from "@/commons/resources/images/logos/fiamma.png"
import ServerObj from "@/www/pages/server/objects/Main/ServerObj";
import FileHandler from "@/www/pages/server/objects/file/FileHandler";

import homeContentCreatorBanner from "@/commons/resources/images/backgrounds/homeContentCreatorBanner.png";
import SimoneCaglioni from "@/commons/resources/images/erenblaze/SimoneCaglioni.png";
import Redirects from "@/commons/utils/Redirects";
import CustomButton from "@/commons/components/buttons/customButton/CustomButton";

const Home = () => {
    const [servers, setServers] = useState<ServerObj[]>([]);
    const listRef = useRef<HTMLDivElement>(null);
    const [paused, setPaused] = useState(false);
    const timeoutRef = useRef<NodeJS.Timeout | null>(null);
    const [scrollDirection, setScrollDirection] = useState<'right' | 'left'>('right');
    const [canScrollLeft, setCanScrollLeft] = useState(false);
    const [canScrollRight, setCanScrollRight] = useState(false);
    const [isCentered, setIsCentered] = useState(false);
    const [manualPause, setManualPause] = useState(false);

    async function FileManager() {
        setServers([]);
        const files = await FileHandler.getFileList();

        if (!Array.isArray(files)) {
            console.error("FileHandler.getFileList() did not return an array:", files);
            return;
        }

        const loadedServers: ServerObj[] = [];
        for (const fileName of files) {
            const fileData = await FileHandler.loadFile(fileName);
            const obj = new ServerObj(fileData.title, fileData.description, fileData.preview, fileName);
            loadedServers.push(obj);
        }

        setServers(loadedServers);
    }

    useEffect(() => {
        const el = listRef.current;
        if (!el) return;

        if (el.scrollWidth <= el.clientWidth) {
            setIsCentered(true);
        } else {
            setIsCentered(false);
        }
    }, [servers]);
    const handlePause = () => {
        setManualPause(true);
    };
    const handleResume = () => {
        setManualPause(false);
    };

    useEffect(() => {
        FileManager();
    }, []);

    const autoScroll = (el: any, interval: any) => {
        const maxScroll = el.scrollWidth - el.clientWidth;
        if (scrollDirection === 'right') {
            el.scrollLeft += 1;
            if (el.scrollLeft >= maxScroll - 1) {
                clearInterval(interval);
                setScrollDirection('left');
                setPaused(true);
                setTimeout(() => {
                    setPaused(false);
                }, 2000);
            }
        } else {
            el.scrollLeft -= 1;
            if (el.scrollLeft <= 0) {
                clearInterval(interval);
                setScrollDirection('right');
                setPaused(true);
                setTimeout(() => {
                    setPaused(false);
                }, 2000);
            }
        }
    }

    useEffect(() => {
        const el = listRef.current;
        if (!el || servers.length === 0 || isCentered) return;

        let interval: NodeJS.Timeout;

        if (paused || manualPause) {
        } else {
            interval = setInterval(() => {
                autoScroll(el, interval);
            }, 10);
        }

        return () => {
            clearInterval(interval);
            if (timeoutRef.current) clearTimeout(timeoutRef.current);
        };
    }, [paused, scrollDirection, servers, manualPause, isCentered]);

    const updateScrollButtons = () => {
        const el = listRef.current;
        if (!el) return;

        setCanScrollLeft(el.scrollLeft > 40);
        setCanScrollRight(el.scrollLeft < el.scrollWidth - el.clientWidth - 40);
    };

    useEffect(() => {
        updateScrollButtons(); // iniziale
        const el = listRef.current;
        if (!el) return;

        el.addEventListener("scroll", updateScrollButtons);
        window.addEventListener("resize", updateScrollButtons);

        return () => {
            el.removeEventListener("scroll", updateScrollButtons);
            window.removeEventListener("resize", updateScrollButtons);
        };
    }, []);

    const scrollBy = (amount: number) => {
        const el = listRef.current;
        if (!el) return;

        setPaused(true);
        el.scrollBy({left: amount, behavior: 'smooth'});

        setTimeout(() => setPaused(false), 600);
    };


    return (
        <>
            <Background/>
            <div className={styles.home__body}>
                <Header/>

                <div className={styles.page__content}>
                    <div className={styles.homeBox}>
                        <div className={styles.mainBox}>
                            <span className={styles.mainTitle}>
                                Benvenutə nel<br/>Network EBLCraft
                            </span>
                            <br/>
                            Benvenutə nel sito ufficiale di EBLCraft!<br/>
                            Da qui potrai accedere alla <a href={environment.reportsUrl}>Sezione Reports</a> per
                            chiedere
                            supporto al nostro Staff per qualsiasi tipologia di problema.<br/>
                        </div>
                    </div>
                    <div className={styles.shadowBottom}></div>
                </div>

                <div className={styles.page__secondaryContent}>
                    <div className={styles.homeSecondaryBox}>
                        <div className={styles.secondaryBoxElement}>
                            <img src={flame} alt="EBLCraft Logo"/>
                            <div>
                                <p className={styles.secondarySubTitle}>ABOUT US</p>
                                <p className={styles.secondaryTitle}>EBLCraft</p>
                                EBLCraft è una community italiana di Minecraft nata nel 2019 con l’obiettivo di offrire
                                uno spazio creativo e accogliente per tutti gli appassionati del gioco.<br/>
                                Nel corso degli anni, è cresciuta grazie al contributo dei suoi membri, diventando un
                                punto di riferimento per chi cerca un ambiente dove esprimere la propria creatività e
                                condividere esperienze con altri giocatori.<br/><br/>
                                La nostra missione è quella di fornire un luogo dove ogni giocatore possa sentirsi parte
                                di una comunità attiva e coinvolgente, partecipando a progetti comuni, eventi e attività
                                che valorizzano la collaborazione e l'immaginazione.<br/>
                                Se stai cercando un server dove costruire, esplorare e divertirti insieme ad altri
                                appassionati, EBLCraft è il posto giusto per te.
                            </div>
                        </div>
                    </div>
                </div>

                <div className={styles.page__serverContent}>
                    <div className={styles.page__serverContentTitle}>SCOPRI LE MODALITÀ</div>

                    <div className={styles.serverScrollWrapper}>
                        {canScrollLeft && (
                            <CustomButton className={styles.scrollLeft} onClick={() => scrollBy(-430)}>←</CustomButton>
                        )}

                        <div
                            className={`${styles.page__serverContentList} ${isCentered ? styles.centered : ''}`}
                            ref={listRef}
                            onMouseEnter={() => handlePause()}
                            onMouseLeave={() => handleResume()}
                            onTouchStart={() => handlePause()}
                            onTouchEnd={() => handleResume()}
                        >
                            {servers?.map((obj, index) => (
                                <React.Fragment key={index}>
                                    {obj.previewRender()}
                                </React.Fragment>
                            ))}
                        </div>

                        {canScrollRight && (
                            <CustomButton className={styles.scrollRight} onClick={() => scrollBy(430)}>→</CustomButton>
                        )}
                    </div>
                </div>

                <div className={styles.contentCreatorZone}>
                    <img className={styles.contentCreatorBanner} src={homeContentCreatorBanner}/>
                    <span className={styles.contentCreatorTitle}>ERENBLAZE</span>
                    <div className={styles.contentCreatorGrid}>
                        <img src={SimoneCaglioni}/>
                        <div>
                            Mi chiamo Simone Caglioni, ma online sono meglio conosciuto come ErenBlaze, uno youtuber e
                            content creator specializzato in contenuti legati al mondo dei videogiochi. Il mio canale
                            YouTube è stato fondato nel maggio 2013 e, da allora, ho raggiunto un pubblico di oltre
                            827.000 iscritti e accumulato più di 484 milioni di visualizzazioni complessive.
                            <br/><br/>
                            <div className={styles.contentCreatorRight}>
                                <button className={styles.button} onClick={(e) => {
                                    Redirects.send("erenblaze", e);
                                }}>DI PIÙ ➜</button>
                            </div>
                        </div>
                    </div>
                </div>

                <Footer/>
            </div>
        </>
    );
};

export default Home;